import BaseModel from '@/utils/model'
import { isNumber } from 'lodash'
/**
 * 询价管理 询价单基础数据
 */
export default class PartModel extends BaseModel {
    /**
     *  全部零件的数组
     */
    parts = []

    /**
     *  供应商列表(去重)
     */
    supplierList = []

    /**
     *  零件列表(去重)
     */
    partList = []

    /**
     *  以供应商为维度的零件列表
     */
    // supplierTree = []

    /**
     *  以零件为维度,供应商比价的列表
     */
    // partTree = []

    supplierMap = new Map()
    partMap = new Map()
    /**
     * 
     * @param {PartItem[]} parts 
     */
    // constructor(parts) {
    //     this.parts = parts
    //     this.initData()
    // }

    /**
     * 初始化数据
     */
    initData() {
        this.parts.forEach(p => {
            /**零件的供应商Id */
            const sId = p.rfqSupplierId
            /**零件的id */
            const pId = p.rfqPartId

            //处理供应商维度的零件列表

            if (this.supplierMap.has(sId)) {
                this.supplierMap.get(sId).push(p)
            } else {
                const supplierClean = {
                    id: p.rfqSupplierId,
                    code: p.rfqSupplierCode,
                    name: p.rfqSupplierName,
                }
                this.supplierList.push(supplierClean)

                const list = [p]
                this.supplierMap.set(sId,list)
                
                supplierClean.parts = list
            }

            //处理零件为维度的 不同供应商区分的列表
            if (this.partMap.has(pId)) {
                this.partMap.get(pId).push(p)

            } else {
                const partClean = {
                    id: p.rfqPartId,
                    name: p.partName,
                    code: p.partCode,
                    unit: p.unit,
                    oneCarCount: p.oneCarCount,
                    targetPrice: p.targetPrice,
                    minPartPrice: {}
                }
                this.partList.push(partClean)

                const list = [p]
                this.partMap.set(pId, list)
                partClean.suppliers = list
                console.log(list, '=================')
                this.getMinPartPrice(partClean, list)
            }
            
        })
    }

    getMinPartPrice(partClean, list) {
        list.forEach(item => {
            Object.keys(item).forEach(key => {
                if (isNumber(item[key])) {
                    partClean.minPartPrice[key + 'Min'] = partClean.minPartPrice[key + 'Min'] ? Math.min(item[key], partClean.minPartPrice[key + 'Min']) : item[key]
                }
            })
        })
        console.log(partClean.minPartPrice, 'partClean.minPartPrice')
    }

    getPartEchartsOption(data) {
        // console.log(data)
        const suppNameList = data.suppliers.map(v =>{
            return v.rfqSupplierName
        })

        const  arrayA = []
        const  arrayB = []
        const  arrayC = []

        const  arrayE = []
        const  arrayF = []
        const  arrayG = []

        const  arrayI = []

        const  arrayK = []
        const  arrayL = []
        const  arrayN = []

        const  arrayP = []

        data.suppliers.forEach(v =>{
            arrayA.push(v.materialCost)
            arrayB.push(v.outsidePartCost)
            arrayC.push(v.processingCost)
            arrayE.push(v.managementCost)
            arrayF.push(v.saleCost)
            arrayG.push(v.accountCost)
            arrayI.push(v.profit)
            arrayK.push(v.packageFee)
            arrayL.push(v.transportFee)
            arrayN.push(v.amortizationMoney)
            arrayP.push(v.taxCost)
        })

        const sections = [
            {
                name: '原材料A',
                data: arrayA,
            },
            {
                name: '外购零部件B',
                data: arrayB,
            },
            {
                name: '加工费C',
                data: arrayC,
            },
            {
                name: '管理费用E',
                data: arrayE,
            },
            {
                name: '销售费用F',
                data: arrayF,
            },
            {
                name: '财务费用G',
                data: arrayG,
            },
            {
                name: '利润I',
                data: arrayI,
            },
            {
                name: '包装费K',
                data: arrayK,
            },
            {
                name: '运输费L',
                data: arrayL,
            },
            {
                name: '分摊N',
                data: arrayN,
            },
            {
                name: '增值税',
                data: arrayP,
            },
        ]
        const series = sections.map(v =>{
            return {
                name: v.name,
                type: 'bar',
                stack: 'total',
                label: {
                    show: true
                },
                emphasis: {
                    focus: 'series'
                },
                data: v.data,
            }
        })

        const options = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                // Use axis to trigger tooltip
                type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                }
            },
            legend: {},
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'value'
            },
            yAxis: {
                type: 'category',
                data: suppNameList,
            },
            series,
        }

        return options
    }

}
